import React from 'react'
import { Grid, Box } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiAlertOctagon } from '@mdi/js'

import useStyles from '../../styles'

const FormErrorBanner = ({ loading = false, nfseError }) => {
  const classes = useStyles()

  if (!loading && !nfseError) return null

  return (
    <Grid item xs={12}>
      <Box className={classes.nfseError}>
        <Icon path={mdiAlertOctagon} size={1} />

        <p>
          {loading ? 'NFSe com erro! Aguarde para informações...' : nfseError}
        </p>
      </Box>
    </Grid>
  )
}

export default FormErrorBanner
